import React, { useState } from "react";
import { newLogo } from "../../assets/Images";
import { PlayIcon, PauseIcon, BackwardIcon, ForwardIcon } from "@heroicons/react/24/solid";

export default function MiniAudioPlayer() {
  const [isPlaying, setIsPlaying] = useState(false);

  // Generate some dynamic height bars for the audio visualizer
  const visualizerBars = [
    12, 24, 18, 32, 10, 28, 40, 16, 22, 34, 14, 30, 20, 38, 12, 26, 18, 35, 10, 24
  ];

  return (
    <div className="w-full bg-[#B87A1B] text-black py-4 px-6 md:px-12 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-[0_-5px_20px_rgba(184,122,27,0.3)] sticky bottom-0 z-50 select-none">
      {/* Left: Thumbnail & Info */}
      <div className="flex items-center gap-4 w-full sm:w-auto">
        <div className="w-14 h-14 bg-black rounded flex flex-col items-center justify-center p-1.5 shrink-0 border border-black/20">
          <img src={newLogo} alt="BAB Logo" className="object-contain h-2/3 w-2/3" />
          <span className="text-[7px] text-[#B87A1B] font-bold font-oswald tracking-widest uppercase">
            Coming Soon
          </span>
        </div>
        <div className="flex flex-col text-left">
          <span className="font-outfit text-sm font-bold leading-tight">
            Soulflow Records Track
          </span>
          <span className="font-outfit text-xs opacity-75">
            B.A.B Music Player
          </span>
        </div>
      </div>

      {/* Middle: Controls */}
      <div className="flex items-center gap-6">
        <button className="text-black/80 hover:text-black transition-colors focus:outline-none">
          <BackwardIcon className="w-6 h-6" />
        </button>
        <button
          onClick={() => setIsPlaying(!isPlaying)}
          className="w-12 h-12 rounded-full bg-black text-[#B87A1B] hover:bg-neutral-900 transition-all flex items-center justify-center focus:outline-none shadow-md hover:scale-105"
        >
          {isPlaying ? (
            <PauseIcon className="w-6 h-6" />
          ) : (
            <PlayIcon className="w-6 h-6 translate-x-[1px]" />
          )}
        </button>
        <button className="text-black/80 hover:text-black transition-colors focus:outline-none">
          <ForwardIcon className="w-6 h-6" />
        </button>
      </div>

      {/* Right: Audio Wave Visualizer */}
      <div className="hidden md:flex items-end gap-[3px] h-10 px-4">
        {visualizerBars.map((height, i) => (
          <div
            key={i}
            className={`w-[3px] bg-black/40 rounded-t-sm transition-all duration-300`}
            style={{
              height: `${isPlaying ? height : Math.max(4, height / 3)}px`,
              animation: isPlaying ? `waveBounce 1.2s ease-in-out infinite alternate` : "none",
              animationDelay: `${i * 0.08}s`
            }}
          />
        ))}
      </div>

      {/* Embedded Animation Styles */}
      <style>{`
        @keyframes waveBounce {
          0% { transform: scaleY(0.4); }
          100% { transform: scaleY(1.2); }
        }
      `}</style>
    </div>
  );
}
